module.exports = __webpack_public_path__ + "static/feature-calendar-3280573d6e47c9bbb51deb09a91a32e7.png";